import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/api";

export const Footer = () => (
    <footer data-testid="footer" className="border-t border-zinc-200 mt-24 bg-zinc-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
                <img src={LOGO_URL} alt="Flexible Workspace Group" className="h-12 w-auto" />
                <p className="mt-5 text-sm text-zinc-600 max-w-sm">
                    Premium virtual business addresses across the Philippines. One marketplace.
                    Verified spaces. A recall-rich business address for your next chapter.
                </p>
            </div>
            <div className="md:col-span-3">
                <div className="text-[10px] tracking-label uppercase text-zinc-500">Platform</div>
                <ul className="mt-4 space-y-2 text-sm">
                    <li><Link to="/search" className="hover:underline">Browse Addresses</Link></li>
                    <li><Link to="/enroll" className="hover:underline">Enroll a Center</Link></li>
                    <li><Link to="/dashboard" className="hover:underline">Dashboard</Link></li>
                </ul>
            </div>
            <div className="md:col-span-2">
                <div className="text-[10px] tracking-label uppercase text-zinc-500">Brands</div>
                <ul className="mt-4 space-y-2 text-sm text-zinc-700">
                    <li>Loud Crowd Coworking</li>
                    <li>Prime Coworking &amp; Start-up Labs</li>
                </ul>
            </div>
            <div className="md:col-span-2">
                <div className="text-[10px] tracking-label uppercase text-zinc-500">Reach us</div>
                <ul className="mt-4 space-y-2 text-sm text-zinc-700">
                    <li>flexiblework.space</li>
                    <li>Manila · Philippines</li>
                </ul>
            </div>
        </div>
        <div className="border-t border-zinc-200">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 flex items-center justify-between text-xs text-zinc-500">
                <span>© {new Date().getFullYear()} Flexible Workspace Group</span>
                <span className="tracking-label uppercase">A Registered Business Address · PH</span>
            </div>
        </div>
    </footer>
);

export default Footer;
